const scrollToTitle = () => {
  const tocElement = document.getElementsByClassName('terms-and-conditions')[0];
  if (!tocElement) return;
  const height = tocElement.getBoundingClientRect().height;
  const documentHeight = document.documentElement.scrollHeight;
  const y = documentHeight - height;
  window.scrollTo({ top: y, behavior: 'smooth' });
};

export const scrollToTermsAndConditions = () => {
  // make sure the DOM is fully updated
  setTimeout(() => {
    scrollToTitle();
  }, 1);
};
